// extracted by mini-css-extract-plugin
export var headerCell = "_4r-1";
export var loadingSpinnerContainer = "_4r-4";
export var rowWrapper = "_4r-3";
export var standaloneTable = "_4r-5";
export var table = "_4r-0";
export var white = "_4r-2";